const HRWConstant = {
    hrwBaseUrl: 'https://accounts.haravan.com/',
    clientId: process.env.REACT_APP_HRV_APP_ID,
    clientSecret: process.env.REACT_APP_HRV_APP_SECRET,
    accessTokenUri: 'https://accounts.haravan.com/connect/token',
    authorizationUri: 'https://accounts.haravan.com/connect/authorize',
    redirectUri: process.env.REACT_APP_HRV_OAUTH_CALLBACK_URL,
    scope_string: 'openid userinfo profile org hr_api.read_emp_basic',
    scopes: ['openid', 'userinfo', 'profile', 'org', 'hr_api.read_emp_basic'],
    grant_type: 'authorization_code',
    responseType: 'code id_token',
    responseMode: 'form_post',
};

export default HRWConstant;
